import { Component, HostBinding, OnInit } from '@angular/core';
import { TextAreaFormControl } from './text-area.control';
import { BasespaceStatus } from '../bs-app-launch-form-control';
import { BsAppLaunchFormService } from '../../services/bs-app-launch-form.service';
import { BsAppLaunchFormControlBaseComponent } from '../bs-app-launch-form-control-base.component';

@Component({
  selector: 'app-bs-app-launch-text-area-control',
  templateUrl: './bs-app-launch-text-area-control.component.html',
  styleUrls: ['./bs-app-launch-text-area-control.component.scss'],
})
export class BsAppLaunchTextAreaControlComponent extends BsAppLaunchFormControlBaseComponent<TextAreaFormControl> implements OnInit {
  @HostBinding('attr.basespace-status')
  get basespaceStatus(): BasespaceStatus {
    return this.formControl ? this.formControl.basespaceStatus : null;
  }

  formControl: TextAreaFormControl;

  constructor(bsAppLaunchFormService: BsAppLaunchFormService) {
    super(bsAppLaunchFormService);
  }

  ngOnInit(): void {}

  onBlur(): void {
    this.checkAndFireFormUpdate();
  }

}
